/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaListDialog/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function TysiaListDialog({
  children,
  viewPath = "/DesignSystem/TysiaListDialog",
  width = 260,
  maxWidth = 260,
  height = 328,
  maxHeight = 328
  
}) {
  let isBefore = useIsBefore()
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaListDialog.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-23swzs': typeof width === 'number' ? `${width}px` : width,'--mw-2-23swzs': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--h-3-23swzs': typeof height === 'number' ? `${height}px` : height,'--mh-4-23swzs': typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,'--bblr-5-23swzs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-23swzs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-7-23swzs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-8-23swzs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-9-23swzs': dtColorsNeutral200,'--bc-10-23swzs': dtColorsWhite,'--g-11-23swzs': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-12-23swzs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-13-23swzs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--o-14-23swzs': isBefore ? 0 : 1,'--ty-15-23swzs': isBefore ? "-8px" : "0px"}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}